<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
      <specialEdition :type='type'></specialEdition>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import specialEdition from '@/components/specialEdition'
export default {
  data () {
    return {
      navBlock: '專輯  /  專輯列表',
      navtitle: '新增專輯',
      type:'add',
    }
  },
  components: {
    NavBar,
    specialEdition
  }
};
</script>>



// WEBPACK FOOTER //
// src/pages/specialEdition/addSpecialEdition.vue